import React from 'react';
import { IconButton, Box, Button, Modal, darken } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { styled } from '@mui/material/styles';

export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media (max-width: 399px)': {
    minWidth: '100%',
  },
  '@media (min-width: 400px)': {
    minWidth: 400,
    maxWidth: '100%',
  },
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  pb: 3,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxHeight: '80%',
};

const ContentBox = styled(Box)(({ theme }) => ({
  height: 'calc(100% - 88px)',
  overflowY: 'scroll',
  overflowX: 'hidden',
  padding: `0 ${theme.spacing(2)}`,
  minHeight: '60px',
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const NewModal = (props) => {
  const { children, open, onClose, buttons, hideBackdrop } = props;
  const firstBtn = buttons.length > 1 ? buttons[1] : buttons[0];
  const secondBtn = buttons.length === 1 ? null : buttons[0];

  return (
    <Modal open={open} hideBackdrop={hideBackdrop || false}>
      <Box
        sx={{
          ...modalStyle,
        }}
      >
        <Box display="flex" justifyContent="end" sx={{ mb: 2 }}>
          <IconButton aria-label="close" size="large" onClick={onClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <ContentBox>{children}</ContentBox>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            margin: '32px auto 16px',
            gap: '8px',
          }}
        >
          {secondBtn && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={secondBtn.onClick}
            >
              {secondBtn.label}
            </Button>
          )}
          <Button
            color={firstBtn.color || 'secondary'}
            variant="contained"
            disabled={firstBtn.disabled || false}
            onClick={firstBtn.onClick}
          >
            {firstBtn.label}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NewModal;
